// AI Generated File
import { Component, OnInit } from '@angular/core';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/ng2/services/mon-event/mon-event.service';
import { PagePerformanceProfileService } from '@client/app/services/entities/page-performance/page-performance-profile.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import { ToastService } from '@monsido/angular-shared-components';
import { PagePerformanceService } from '@client/app/modules/page-performance/services/page-performance/page-performance.service';
import { PagePerformanceProfileObsService } from '@client/app/modules/page-performance/services/profile-obs/profile-obs.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { NgbModalOpenerService } from '@client/app/services/ngb-modal-opener/ngb-modal-opener.service';
import {
    FormPagePerformanceConfirmArchiveComponent,
} from '@client/app/modules/page-performance/forms/confirm-archive/confirm-archive.component';
import {
    FormPagePerformanceProfileComponent,
} from '@client/app/modules/page-performance/forms/profile/form-page-performance-profile.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'admin-page-performance-profiles',
    templateUrl: './profiles.component.html',
    standalone: false,
})
export class AdminPagePerformanceProfilesComponent extends BaseContainerComponentController implements OnInit {
    promise: any = null;
    profiles: any = [];
    totalActive: number = 0;
    tabs: any[] = [];
    override activeTab: string = 'active';
    override page: number = 1;
    showHeading: boolean = false;
    saving: boolean = false;

    constructor (
        private pagePerformanceProfileService: PagePerformanceProfileService,
        private modalService: MonModalService,
        private translateService: TranslateService,
        private toastService: ToastService,
        private pagePerformanceService: PagePerformanceService,
        private pagePerformanceProfileObsService: PagePerformanceProfileObsService,
        private monEventService: MonEventService,
        private ngbModalOpenerService: NgbModalOpenerService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.promise = null;
        this.profiles = [];
        this.totalActive = 0;
        this.tabs = [
            {
                name: this.translateService.getString('Active'),
                value: 'active',
            },
            {
                name: this.translateService.getString('Archived'),
                value: 'archived',
            },
        ];
        this.activeTab = 'active';
        this.page = 1;
        this.showHeading = false;
        this.getPage = this.getPageData.bind(this);
        this.getPageData();
    }

    getPageData (isArchived?: boolean): void {
        const params = {
            page: this.page,
            page_size: this.pageSize,
            archived: isArchived || this.activeTab === 'archived',
        };

        this.promise = this.pagePerformanceProfileService.getAll(params, contextTokens.NO_GLOBAL).then((profiles: any) => {
            this.showHeading = true;
            this.profiles = profiles;
            this.updateDropdowns();
            if (!isArchived) {
                this.totalActive = this.profiles.total || 0;
            }
        });
    }

    private updateDropdowns (): void {
        for (const profile of this.profiles) {
            const dropdown = [
                {
                    label: this.translateService.getString('Edit'),
                    leftIcon: 'faEdit',
                    action: () => this.openProfile(profile),
                    shouldShow: !profile.archived_at,
                },
                {
                    label: this.translateService.getString('Archive'),
                    leftIcon: 'faArchive',
                    action: () => this.confirmArchive(profile),
                    shouldShow: !profile.archived_at,
                },
                {
                    label: this.translateService.getString('Restore'),
                    leftIcon: 'faBox',
                    action: () => this.confirmRestore(profile),
                    shouldShow: Boolean(profile.archived_at),
                },
            ];

            profile.dropdown = dropdown.filter((option: any) => option.shouldShow !== false).map((item: any) => {
                return {
                    label: item.label,
                    leftIcon: item.leftIcon,
                    action: item.action,
                };
            });
        }
    }

    openProfile (profile?: any): void {
        if (this.getAvailableProfiles() || profile) {
            const params = {
                body: FormPagePerformanceProfileComponent,
                size: 'md',
                data: {
                    profile: profile,
                },
            };
            const callback = (newProfile: any) => {
                if (typeof newProfile !== 'undefined') {
                    this.getPageData();
                    this.pagePerformanceProfileObsService.updateProfile(newProfile);
                }
            };
            this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
        } else {
            this.requestMoreProfiles();
        }
    }

    private requestMoreProfiles (): void {
        this.monEventService.run('actionTrigger', { action: 'maximum-number-of-profiles-confirm-confirmed' });
        this.saving = true;
        this.pagePerformanceService.requestMoreProfiles(this.translateService.getString('Contact me about more performance profiles'))
            .then(() => {
                this.toastService.success(this.translateService.getString('Our team has been notified of your request. We will soon be in touch.'));
            })
            .finally(() => {
                this.saving = false;
            });
    }

    confirmArchive (profile: any): void {
        // Note: Original used uibModalOpenerService to open 'formPagePerformanceConfirmArchive'
        // component which showed affected pages. For now using simple confirm.
        // TODO: Implement full confirm archive modal with affected pages list
        const modal = this.ngbModalOpenerService.open({
            size: 'lg',
            component: FormPagePerformanceConfirmArchiveComponent,
            resolve: {
                profile,
            },
        });
        modal.result
            .then(() => {
                this.archiveProfile(profile);
                // Match original behavior: switch to archived tab and refresh
                this.activeTab = 'archived';
                this.page = 1;
                this.getPageData(); // Get archived profiles
                this.getPageData(false); // Also refresh active profiles count
            })
            .catch((e) => {

            });
    }

    private archiveProfile (profile: any): void {
        profile.archive = true;
        this.pagePerformanceProfileService.archive(profile).then((archivedProfile: any) => {
            this.toastService.success(this.translateService.getString('The profile has been archived.'));
            this.pagePerformanceProfileObsService.removeProfile(archivedProfile);
        });
    }

    confirmRestore (profile: any): void {
        if (this.getAvailableProfiles() > 0) {
            this.modalService
                .confirm({
                    title: this.translateService.getString('Restore profile?'),
                    message: this.translateService.getString(
                        'Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.',
                        { profileName: profile.name },
                    ),
                })
                .then(() => {
                    this.restoreProfile(profile);
                });
        } else {
            this.modalService
                .confirm({
                    message: this.translateService.getString(
                        '<p class=\'warning\'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached ' +
                        'the limit of the amount of profiles allowed on your account ' +
                        '([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan ' +
                        'or archive some profiles before restoring this one.</p>',
                        { maxProfiles: this.pagePerformanceService.getMaxProfileCount() },
                    ),
                })
                .then(() => {
                    this.restoreProfile(profile);
                });
        }
    }

    getAvailableProfiles (): number {
        if (Array.isArray(this.profiles)) {
            const maxProfileCount = this.pagePerformanceService.getMaxProfileCount();
            return maxProfileCount - (this.totalActive || 0);
        }
        return 0;
    }

    getAvailableProfilesText (): string {
        const availableCount = this.getAvailableProfiles();
        return this.translateService.getString('You can create another [[customerProfilesLimit]] profiles for your account', {
            customerProfilesLimit: availableCount,
        });
    }

    private restoreProfile (profile: any): void {
        profile.archive = false;
        this.pagePerformanceProfileService.archive(profile).then((restoredProfile: any) => {
            this.toastService.success(this.translateService.getString('The profile has been restored.'));
            this.pagePerformanceProfileObsService.addProfile(restoredProfile);
            this.activeTab = 'active';
            this.page = 1;
            this.getPageData();
        });
    }
}
